import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Contact } from "../../../models/Contact";
import { Practice } from "../../../models/Practice";
import { select, Store } from "@ngrx/store";
import { AppState } from "../../../state/reducers";
import {
  ClearNewConversationError,
  NewConversation,
  GetMoreNewConversationPatients,
  SetNewConversationClient,
} from "../../../conversation/state/actions";
import { getOpenConversations } from "../../../waiting-room/state/selectors";
import { takeWhile } from "rxjs/operators";
import { Observable, Subscription } from "rxjs";
import { Conversation } from "../../../models/Conversation";
import { Router } from "@angular/router";
import { Channel } from "../../../../app/enums/channel";
import { Client } from "../../../../app/models/Client";
import { NewConversationError } from "../../../../app/interfaces/new-conversation-error";
import {
  getConversation,
  getNewConversationPatients,
  getNewConversationError,
} from "../../../../app/conversation/state/selectors";
import { phone } from "phone";
import {
  getCurrentPractice,
  getPracticeTemplates,
} from "../../../../app/practices/state/selectors";
import { UntypedFormControl, Validators } from "@angular/forms";
import { GetPracticeTemplates } from "../../../../app/practices/state/actions";
import { practiceHasFeature } from "../../../../app/helpers/practice-has-feature";
import { PracticeFeature } from "../../../../app/enums/practice-feature";
import { getNewConversationPrefilledData } from "../../../dialogs/state/selectors";
import {
  getStandardAndCampaignTemplate,
  getStandardTypeTemplates,
  getTemplates,
} from "../../../templates/state/selectors";
import { Template } from "src/app/models/Template";
import { Media } from "../../../models/Media";
import { DialogTemplateSelectorComponent } from "../dialog-template-selector/dialog-template-selector.component";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { EnvironmentService } from "../../../services/environment.service";
import { phoneValidator } from "../../../helpers/phone-validator";
import { TemplateMergeFieldDo } from "../../../interfaces/template-merge-field.do.interface";
import { ConversationService } from "../../services/conversation.service";
import { TranslateService } from "@ngx-translate/core";
import { GetConversations } from "../../../waiting-room/state/actions";
import { Patient } from "../../../models/Patient";
import { PatientsModule } from "../../../patients/patients.module";
import { IsThisHourPipeModule } from "ngx-date-fns";
import { getPermittedMessagingChannels } from "../../../helpers/get-permitted-messaging-channels";
import { getEmbedSettings, isEmbedMode } from "../../../state/selectors";
import { EmbedPartner } from "../../../enums/embed-partner";

interface ChannelOption {
  name: Channel;
  code: Channel;
  className: string;
  icon: string;
  inactive: boolean;
}

@Component({
  selector: "new-conversation",
  templateUrl: "./new-conversation.component.html",
  styleUrls: ["./new-conversation.component.scss"],
  providers: [DialogService],
})
export class NewConversationComponent
  implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild("initialMessageInput")
  initialMessageInput?: ElementRef<HTMLInputElement>;
  @Input() practice?: Practice;
  @Output() conversationCreated = new EventEmitter();
  @Output() closed = new EventEmitter();
  step = 0;
  alive = true;
  loading = false;
  channels: ChannelOption[] = [];
  selectedChannel?: ChannelOption;
  selectedClient?: Client;
  selectedContact?: Contact;
  conversations$?: Observable<Conversation[]>;
  conversationsSub$?: Subscription;
  conversations?: Conversation[];
  error$?: Observable<NewConversationError | null>;
  error: NewConversationError | null = null;
  phoneNumber = "";
  phoneNumberIsValid = false;
  messagePhoneDirectly = false;
  showPatientSelector = false;
  initialMessage = new UntypedFormControl("");
  initialMessageRequired = false;
  messagingChannel = Channel;
  initialMessageTooLong = false;
  maxInitialMessageLength = 1450;
  remainingInitialMessageLength = this.maxInitialMessageLength;
  showTemplateDialog = false;
  templates$?: Observable<Template[]>;
  templates: Template[] = [];
  facebookLinked = false;
  instagramLinked = false;
  channel = Channel;
  minStep = 0;
  usingTemplate = false;
  selectedTemplate: Template | null = null;
  selectedTemplateMergeFields: TemplateMergeFieldDo[] | null = null;
  selectedTemplateContent: string | null = null;
  showInitialMessageError = false;
  resizeTimeout: any;
  device = "desktop";
  previewOpen = false;
  messagePreviewText: string | null = null;
  selectedMedia: Media | undefined = undefined;
  previewType: string | null = null;
  selectTemplateDialog?: DynamicDialogRef;
  practiceChannel: Channel = Channel.WHATSAPP;
  helpLink = "";
  buttonLink?: string;
  patientsLoading = false;
  patientsPage = 0;
  patients: Patient[] = [];
  selectedPatient: Patient | undefined;
  currentPractice: Practice | null = null;

  embedMode$?: Observable<boolean>;
  embedMode = false;
  private embedPartner: EmbedPartner | null = null;

  constructor(
    private store: Store<AppState>,
    private router: Router,
    public dialogService: DialogService,
    private environmentService: EnvironmentService,
    private conversationService: ConversationService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {

    if (this.practice) {
      this.store.dispatch(GetConversations({ practiceId: this.practice.id }));
    }
    this.subscribeToConversations();
    this.subscribeToPractice();
    this.subscribeToErrors();
    this.subscribeToTemplates();
    this.subscribeToPrefilledData();
    this.store.dispatch(ClearNewConversationError());
    this.getHelpLink();
    this.subscribeToNewConversationPatients();
    this.suscribeToEmbedMode();
    this.subscribeToEmbedSettings();
  }

  subscribeToEmbedSettings(): void {
    this.store.pipe(select(getEmbedSettings)).subscribe(embedSettings => {
      if (embedSettings.partner) {
        this.embedPartner = embedSettings.partner;
      }
    });
  }

  suscribeToEmbedMode(): void {
    this.embedMode$ = this.store
      .pipe(select(isEmbedMode));
    this.embedMode$.subscribe(embedMode => this.embedMode = embedMode)
  }

  ngAfterViewInit(): void {
    this.initialMessage.valueChanges.subscribe((value) => {
      this.conversationService.initialMessage.setValue(
        this.initialMessage.value,
      );
      this.remainingInitialMessageLength =
        this.maxInitialMessageLength - value.length;
      if (this.remainingInitialMessageLength < 0) {
        this.initialMessageTooLong = true;
      } else {
        this.initialMessageTooLong = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.alive = false;
    this.loading = false;
    this.patientsLoading = false;
    this.conversationsSub$?.unsubscribe();
  }

  @HostListener("window:resize")
  handleResize(): void {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.device = this.getDevice();
    }, 100);
  }

  getDevice(): string {
    if (window.innerWidth <= 640) {
      return "mobile";
    }

    return "desktop";
  }

  getHelpLink(): void {
    this.helpLink = "https://help.digitalpractice.vet/en/articles/11631629-how-do-i-add-a-new-template-to-my-digital-practice";
  }

  subscribeToNewConversationPatients(): void {
    this.store
      .pipe(select(getNewConversationPatients))
      .pipe(takeWhile(() => this.alive))
      .subscribe((patients) => {
        this.patients = patients;
        this.patientsLoading = false
      });
  }

  togglePreview(): void {
    this.previewOpen = !this.previewOpen;
  }

  goToStep(step: number): void {
    // If attempting to select Facebook as a channel when the selected contact does not have a Facebook token, don't proceed
    if (step === 5) {
      this.stopUsingTemplate();
      this.messagePreviewText = null;
      this.selectedMedia = undefined;
      this.previewType = null;
      this.selectedTemplateContent = "";
      this.selectedTemplateContent = "";

      if (
        this.selectedChannel &&
        this.selectedChannel.code === Channel.FACEBOOK &&
        !this.facebookLinked
      ) {
        return;
      }

      if (
        this.selectedChannel &&
        this.selectedChannel.code === Channel.INSTAGRAM &&
        !this.instagramLinked
      ) {
        return;
      }
    }

    if (this.step === 2 && this.showPatientSelector === false && step > this.step && step != 1) {
     this.step = step +2
    } else {
      this.step = step
    }

    if (step === 5) {
      setTimeout(() => {
        this.initialMessageInput?.nativeElement.focus();
      }, 0);
    }
  }

  selectPatient(patient: Patient) {
    this.selectedPatient = patient;
    this.goToStep(5)
  }

  handleMorePatients(): void {
    this.patientsPage++;
    this.patientsLoading = true;

    if (this.selectedClient) {
      this.store.dispatch(GetMoreNewConversationPatients({ page: this.patientsPage, client: this.selectedClient, }));
    }

  }

  createConversation(): void {
    if (this.practice) {
      if (
        (this.initialMessageRequired && !this.initialMessage.valid) ||
        this.initialMessageTooLong
      ) {
        this.showInitialMessageError = true;
        this.initialMessage.markAsTouched();
        return;
      }

      this.loading = true;

      if (this.selectedClient && this.selectedContact && this.selectedChannel) {
        this.store.dispatch(
          NewConversation({
            practice: this.practice,
            channel: this.selectedChannel.code,
            client: this.selectedClient,
            contact: this.selectedContact,
            payment: null,
            initialMessage: this.initialMessage.value,
            template: this.usingTemplate ? this.selectedTemplate : null,
            mergeFields: this.selectedTemplateMergeFields,
            buttonLink: this.buttonLink,
            selectedMedia: this.selectedMedia,
            patient: this.selectedPatient ? this.selectedPatient : null
          }),
        );
      } else if (this.phoneNumber && this.selectedChannel) {
        this.store.dispatch(
          NewConversation({
            practice: this.practice,
            channel: this.selectedChannel.code,
            client: null,
            contact: {
              name: "Phone",
              typeCode: "0",
              value: this.phoneNumber,
              facebookLinked: false,
              instagramLinked: false,
            },
            payment: null,
            initialMessage: this.initialMessage.value,
            template: this.usingTemplate ? this.selectedTemplate : null,
            mergeFields: this.selectedTemplateMergeFields,
            buttonLink: this.buttonLink,
            selectedMedia: this.selectedMedia,
            patient: this.selectedPatient
          }),
        );
      }
    }
  }

  onChannelChange(channel: ChannelOption): void {
    this.selectedChannel = channel;

    if (
      this.selectedChannel.code === Channel.WHATSAPP ||
      this.selectedChannel.code === Channel.WHATSAPP360 ||
      this.selectedChannel.code === Channel.WHATSAPP360CLOUD
    ) {
      this.maxInitialMessageLength = 1450;
    }

    if (this.selectedChannel.code === Channel.SMS) {
      this.maxInitialMessageLength = 400;
    }

    this.remainingInitialMessageLength =
      this.maxInitialMessageLength - this.initialMessage.value.length;
  }

  selectClient(client: Client): void {
    if (this.currentPractice) {
      this.showPatientSelector = practiceHasFeature(this.currentPractice, PracticeFeature.ALLOW_PATIENT_SELECTOR);
    }

    this.selectedClient = client;


    if (this.conversations) {
      const conversations = this.conversations.filter((conv) => {
        return (
          conv &&
          conv.client &&
          conv.client.pmsId === this.selectedClient?.pmsId
        );
      });

      if (conversations.length > 0) {
        this.goToStep(4);
        this.step = 4;
      } else {
        this.goToStep(this.step + 1);
      }
    }

    this.store.dispatch(SetNewConversationClient({ client }));

    this.patientsLoading = true
  }

  selectContact(contact: Contact): void {
    const phoneNumber = contact.e164 ? contact.e164 : contact.value;

    let result: string = phoneNumber;
    if (this.practice) {
      result = phoneValidator(phoneNumber, this.practice?.country);
    }

    if (result && phone(result).isValid) {
      this.selectedContact = contact;

      if (this.conversations) {
        const existingConversations = this.conversations.filter((conv) => {
          const externalUser = conv.users
            ? conv.users.find(
                (user) => user.channel !== Channel.INTERNAL,
              )
            : null;

          return externalUser && externalUser.phone && externalUser.phone == phone(result).phoneNumber;
        });

        if (existingConversations.length > 0) {
          this.goToStep(4);
          this.step = 4;
          return
        }
      }

      if (contact.facebookLinked) {
        this.facebookLinked = true;
      }

      if (contact.instagramLinked) {
        this.instagramLinked = true;
      }
      this.goToStep(this.step + 1);
    } else {
      this.goToStep(6);
    }
  }

  subscribeToErrors(): void {
    this.error$ = this.store
      .pipe(select(getNewConversationError))
      .pipe(takeWhile(() => this.alive));

    this.error$.subscribe((error) => {
      this.error = error;
    });
  }

  subscribeToPrefilledData(): void {
    this.store
      .select(getNewConversationPrefilledData)
      .pipe(takeWhile(() => this.alive))
      .subscribe((prefillData) => {
        if (prefillData.client && prefillData.contact) {
          this.selectClient(prefillData.client);
          this.selectContact(prefillData.contact);
          this.minStep = 2;
        }
        else if (prefillData.client) {
          this.selectClient(prefillData.client);
          this.minStep = 1;
        }
      });
  }

  subscribeToConversations(): void {
    this.conversations$ = this.store
      .select(getOpenConversations)
      .pipe(takeWhile(() => this.alive));

    this.conversationsSub$ = this.conversations$.subscribe((conversations) => {
      if (conversations) {
        this.conversations = conversations;
      }
    });
  }

  subscribeToPractice(): void {
    this.store
      .pipe(select(getCurrentPractice))
      .pipe(takeWhile(() => this.alive))
      .subscribe((practice) => {
        this.currentPractice = practice;
        if (practice) {
          this.channels = getPermittedMessagingChannels(practice);
          this.selectedChannel = this.channels[0];

          this.showPatientSelector = practiceHasFeature(practice, PracticeFeature.ALLOW_PATIENT_SELECTOR);

          if (
            practiceHasFeature(practice, PracticeFeature.MESSAGE_DIRECT_NUMBERS)
          ) {
            this.setMessagePhoneDirectly(true);
          } else {
            this.setMessagePhoneDirectly(false);
          }

          if (
            practiceHasFeature(practice, PracticeFeature.FORCE_INITIAL_MESSAGE)
          ) {
            this.setInitialMessageRequired(true);
            this.initialMessage = new UntypedFormControl(
              this.initialMessage.value,
              Validators.required,
            );
          } else {
            this.setInitialMessageRequired(false);
            this.initialMessage = new UntypedFormControl(
              this.initialMessage.value,
            );
          }

          this.store.dispatch(GetPracticeTemplates());
        }
      });
  }

  subscribeToTemplates(): void {
    this.templates$ = this.store
      .pipe(select(getStandardAndCampaignTemplate))
      .pipe(takeWhile(() => this.alive));

    this.templates$.subscribe((templates) => {
      this.templates = templates;
    });
  }

  setInitialMessageRequired(required: boolean): void {
    this.initialMessageRequired = required;
  }

  setMessagePhoneDirectly(enabled: boolean): void {
    this.messagePhoneDirectly = enabled;
  }

  goToClientConversation(): void {
    if (this.error && this.error.existingConversation) {
      if (this.embedMode) {
        this.router.navigateByUrl(`embed/${this.embedPartner}/widget/chat?conversationId=${this.error.existingConversation.id}`);
      } else {
        this.router.navigateByUrl(
          "conversations/" + this.error.existingConversation.id,
        );
      }
    } else if (this.conversations) {
      const conversation = this.conversations.find((conv) => {
        return (
          conv &&
          conv.client &&
          conv.client.pmsId === this.selectedClient?.pmsId
        );
      });

      if (conversation) {
        this.router.navigateByUrl("conversations/" + conversation.id);
      }

      if (this.selectedContact) {
        let phoneNumber = this.selectedContact.e164 ? this.selectedContact.e164 : this.selectedContact.value;
        if (this.practice) {
          phoneNumber = phoneValidator(phoneNumber, this.practice?.country);
        }

        const existingContactConversations = this.conversations.filter((conv) => {
          const externalUser = conv.users
            ? conv.users.find(
                (user) => user.channel !== Channel.INTERNAL,
              )
            : null;

          return externalUser && externalUser.phone && externalUser.phone == phone(phoneNumber).phoneNumber;
        });

        if (existingContactConversations.length > 0) {
          this.router.navigateByUrl("conversations/" + existingContactConversations[0].id);
        }
      }
    }

    this.clearError();
    this.closed.emit();
  }

  clearError(): void {
    this.store.dispatch(ClearNewConversationError());
    this.conversationCreated.emit();
  }

  validatePhoneInput(): void {
    let phoneResult = phone(this.phoneNumber);
    if (!phoneResult.isValid) {
      phoneResult = phone(this.phoneNumber, {
        country: this.practice?.country,
      });
    }

    this.phoneNumberIsValid = !!phoneResult.isValid;
  }

  validateKeyPress($event: KeyboardEvent): void {
    const regex = new RegExp("^[a-zA-Z]+$");
    const key = $event.key;

    if (
      key.length === 1 &&
      !$event.ctrlKey &&
      !$event.metaKey &&
      regex.test(key)
    ) {
      $event.preventDefault();
    }
  }

  usePhoneNumber(): void {
    this.showPatientSelector = false;
    let phoneResult = phone(this.phoneNumber, {
      country: this.practice?.country,
    });
    if (!phoneResult.isValid) {
      phoneResult = phone(this.phoneNumber);
    }

    if (!phoneResult.isValid || !phoneResult.phoneNumber) {
      this.phoneNumberIsValid = false;
      return;
    }

    this.phoneNumber = phoneResult.phoneNumber;
    this.goToStep(2);
  }

  handleBack(currentStep: number): void {
    switch (currentStep) {
      case 1:
        this.goToStep(0);
        this.selectedClient = undefined;
        this.phoneNumber = "";
        this.phoneNumberIsValid = false;
        break;

      case 2:
        if (!this.selectedClient) {
          this.goToStep(0);
          this.phoneNumber = "";
          this.phoneNumberIsValid = false;
        } else {
          this.goToStep(1);
        }
        break;

      case 3:
        this.goToStep(2);
        this.selectedPatient = undefined;
        break;

      case 4:
        this.goToStep(0);
        break;
      case 5:
        if (!this.showPatientSelector) {
          this.goToStep(2);
        } else {
          this.selectedPatient = undefined;
          this.goToStep(3);
        }
        break;
    }
  }

  clearInitialMessage(): void {
    this.initialMessage.setValue("");
  }

  openTemplatesModal(): void {
    this.showInitialMessageError = false;
    this.showTemplateDialog = true;
  }

  closeTemplatesModal(): void {
    this.showInitialMessageError = true;
    this.showTemplateDialog = false;
  }

  selectTemplate(): void {
    this.translateService.get('ui.new_conversation.select_template').pipe(takeWhile(_ => this.alive)).subscribe(header => {
      this.selectTemplateDialog = this.dialogService.open(
        DialogTemplateSelectorComponent,
        {
          header,
          modal: true,
          width: "1000px",
          baseZIndex: 10000,
          data: {
            templates: this.templates,
            client: this.selectedClient,
            patient: this.selectedPatient,
            buttonClass: "p-button-success",
            includeMediaFilter: true,
            allPatients: this.patients,
            isPaymentRequestMode: false,
          },
        },
      );

      this.selectTemplateDialog.onClose.subscribe((result) => {
        if (result) {
          this.handleTemplateSelected(result);
        }
      });
    })
  }

  handleTemplateSelected(event: {
    text: string;
    mergeFields: { placeholderId: string; content: string }[];
    template: Template;
    media?: Media;
    previewType?: string;
    buttonLink?: string;
    patient?: Patient;
  }): void {
    this.initialMessage.setValue(event.text);
    this.selectedTemplateContent = event.text;
    this.selectedTemplate = event.template;
    this.selectedTemplateMergeFields = event.mergeFields;
    this.selectedMedia = event.media;
    this.previewType = event.previewType || null;
    this.buttonLink = event.buttonLink;
    this.usingTemplate = true;

    if (event.patient) {
      this.selectedPatient = { ...event.patient };
    }
    this.closeTemplatesModal();
  }

  editTemplate(): void {
    this.usingTemplate = false;
    this.initialMessageInput?.nativeElement.focus();
  }

  cancelEdits(): void {
    this.usingTemplate = true;
    this.initialMessage.setValue(this.selectedTemplateContent);
  }

  stopUsingTemplate(): void {
    this.clearInitialMessage();
    this.usingTemplate = false;
    this.selectedTemplate = null;
    this.selectedTemplateMergeFields = null;
    this.buttonLink = undefined;
  }
}
